<script>
import api from '@/helpers/apirest/api';
import Modal from "@/components/modals/modal-form.vue";
import Status from "@/helpers/general/status";
import OrderShow from "@/views/pages/orders/show/show.vue";
import CardApplicationsPartial from "@/views/pages/customers/show/partials/card-applications-partial.vue";
import OrdersPartial from "@/views/pages/customers/show/partials/orders-partial.vue";
import YouthCardsPartial from "@/views/pages/customers/show/partials/youth-cards-partial.vue";
import CustomerForm from "@/views/pages/customers/forms/customer-form.vue";
import BasicDataPartial from '@/views/pages/customers/show/partials/basic-data-partial.vue';
import HolderDataPartial from '@/views/pages/customers/show/partials/holder-data-partial.vue';

export default {
    emits: ['onSuccess'],
    props: {
        modalId: String,
        id: Number,
        cardApplicationId: Number
    },
    data() {
        return {
            customer:null,
            showOrderModalId:'order-show-modal',
            formModalId:'customer-form-detail-modal',
            customerIntegrationStatus: Status,
            showSelectedItemId:null,
            activeTab:null
        }
    },
    components: {
        Modal,
        OrderShow,
        CardApplicationsPartial,
        OrdersPartial,
        YouthCardsPartial,
        CustomerForm,
        BasicDataPartial,
        HolderDataPartial
    },
    computed: {
        modalTilte(){
            return `Detalle del cliente #${(this.customer?.id || '')}`;
        },
        status(){
            return Status.getStatus({itemStatus: this?.customer?.status, type: 'card_application_statuses', html: true});
        },
        cardType(){
            return Status.getStatus({itemStatus: this?.customer?.latest_youth_card?.card_type, type: 'youth_card_types'});
        },
        youthCardStatus(){
            return Status.getStatus({itemStatus: this?.customer?.latest_youth_card?.status, type: 'youth_card_status', html: true});
        },
    },
    methods: {
        async getData(){
            if (this.id) {
                const response = await api.get({
                    url: `customers/${this.id}`,
                    config: {
                        withLoading: true
                    }
                });
                this.customer = response?.data?.data;
            }
        },
        shown() {
            this.getData();            
        },
        hidden() {
            this.customer = null;
        },
        cancel() {
            this.$bvModal.hide(this.modalId);
        },
        showFormModal() {
            this.$bvModal.show(this.formModalId);
        },
        onSuccess(){            
            this.getData(); 
        },
    }
};
</script>

<template>
    <div>
        <Modal :title="modalTilte" :id="modalId" @cancel="cancel" @shown="shown" @hidden="hidden" :size="'extra-xl'" :showConfirmButton="false" :label-cancel-btn="'Cerrar'">
            <OrderShow :modal-id="showOrderModalId" :id="showSelectedItemId"></OrderShow>
            <CustomerForm :modal-id="formModalId" :id="customer?.id" @onSuccess="onSuccess"></CustomerForm>
            <div class="row mb-4">
                <div class="col-12 fixed-column">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <b-dropdown no-flip right class="qlk-dropdown-sm" style="position: absolute; top: 10px; right: 10px" variant="light" size="sm">
                                    <template v-slot:button-content>
                                        <i class="mdi mdi-dots-vertical m-0 text-muted font-size-20"></i>
                                    </template>
                                    <b-dropdown-item @click="showFormModal">Editar</b-dropdown-item>
                                </b-dropdown>
                                <div class="col-md-4 col-xs-12 d-flex align-items-center">
                                    <div class="avatar-sm"><span class="avatar-title text-center text-uppercase rounded-circle bg-soft-primary text-primary">
                                        {{ customer?.first_name?.charAt(0) + customer?.last_name?.charAt(0) }}
                                    </span></div> 
                                    <div class="ml-3">
                                        <h4 class="mt-3 mb-0">{{ customer?.name }}</h4>
                                        <p class="text-muted font-size-14 mb-0">
                                            {{ customer?.identification_type?.prefix }}: {{ customer?.identification }}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-2 col-xs-12 d-flex flex-column justify-content-center">
                                    <div class="font-weight-bold">N° Carné Joven.</div>
                                    <div>{{ customer?.latest_youth_card?.code }}</div>
                                </div>
                                <div class="col-md-2 col-xs-12 d-flex flex-column justify-content-center">
                                    <div class="font-weight-bold d-flex align-items-center gap-2">Caducidad <div v-html="youthCardStatus"></div></div>
                                    <div><span v-format-date="customer?.latest_youth_card?.expiration_date "></span></div>
                                </div>
                                <div class="col-md-2 col-xs-12 d-flex flex-column justify-content-center">
                                    <div class="font-weight-bold">Modalidad</div>
                                    <div>{{ cardType }}</div>
                                </div>
                                <div class="col-md-2 col-xs-12 d-flex flex-column justify-content-center" v-if="customer?.identification_media">
                                    <div class="font-weight-bold">Adjunto</div>
                                    <div><a :href="customer?.identification_media?.url" target="_blank">Descargar</a></div>
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card h-100">
                        <div class="card-body">
                            <b-tabs v-model="activeTab" content-class="p-3 text-muted">
                                <b-tab class="border-0" v-if="customer?.customer_type === 'holder'">
                                    <template v-slot:title>
                                        <span class="d-inline-block d-sm-none">
                                            <i class="fas fa-home"></i>
                                        </span>
                                        <span class="d-none d-sm-inline-block">Datos titulares</span>
                                    </template>
                                    <b-card-text>
                                        <HolderDataPartial :customer="customer"></HolderDataPartial>
                                    </b-card-text>
                                </b-tab>
                                <b-tab class="border-0" v-if="customer?.customer_type !== 'holder'">
                                    <template v-slot:title>
                                        <span class="d-inline-block d-sm-none">
                                            <i class="fas fa-home"></i>
                                        </span>
                                        <span class="d-none d-sm-inline-block">Datos básicos</span>
                                    </template>
                                    <b-card-text>
                                        <BasicDataPartial :customer="customer"></BasicDataPartial>
                                    </b-card-text>
                                </b-tab>
                                <b-tab class="border-0" lazy>
                                    <template v-slot:title>
                                        <span class="d-inline-block d-sm-none">
                                            <i class="fas fa-home"></i>
                                        </span>
                                        <span class="d-none d-sm-inline-block">Carné</span>
                                    </template>
                                    <b-card-text>
                                        <YouthCardsPartial :customer="customer"></YouthCardsPartial>
                                    </b-card-text>
                                </b-tab>
                                <b-tab class="border-0" :active="(cardApplicationId) ? true : false" lazy>
                                    <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="fas fa-home"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">Solicitudes</span>
                                    </template>
                                    <b-card-text>
                                        <CardApplicationsPartial :customerId="id"></CardApplicationsPartial>                                        
                                    </b-card-text>
                                </b-tab>
                                <b-tab class="border-0" lazy>
                                    <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="fas fa-home"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">Pedidos</span>
                                    </template>
                                    <b-card-text>
                                        <OrdersPartial :customerId="id"></OrdersPartial>
                                    </b-card-text>
                                </b-tab>                              
                            </b-tabs>                      
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </div>    
</template>